import React from "react";
import "./DevelopmentProgress.scss";

function DevelopmentProgress() {
  return (
    <div className="progress-container">
      <div className="progress-animation">
        <span>D</span>
        <span>e</span>
        <span>v</span>
        <span>e</span>
        <span>l</span>
        <span>o</span>
        <span>p</span>
        <span>m</span>
        <span>e</span>
        <span>n</span>
        <span>t</span>
        <span>&nbsp;</span>
        <span>I</span>
        <span>n</span>
        <span>&nbsp;</span>
        <span>P</span>
        <span>r</span>
        <span>o</span>
        <span>g</span>
        <span>r</span>
        <span>e</span>
        <span>s</span>
        <span>s</span>
        <span>...</span>
      </div>
      <div className="loader"></div>
    </div>
  );
}

export default DevelopmentProgress;
    